import React, { useState } from 'react';
import { WhiteCross, Clock } from './icons/svg';
import { get24HoursTimeNew, get24HoursDateTime } from "../../common/common";
import { renderImg } from './icons/img';
import { BUS_TYPE, DEPOT_NAME, SRD, t } from '../../translations/Search';
const ServiceRouteDtls = ({ data, summaryData, close }) => {
    const { PickupTimings, DropoffTimings } = summaryData;
    const [pickDrop] = useState([...PickupTimings, ...DropoffTimings]);
    const showBusType = (el) => {
        let busType = el.ServiceType ? el.ServiceType : '';
        let serviceType = el.ServiceType
        if (serviceType) {
            // busType += (el.HasAC ? (serviceType.includes("AC") ? '' : ', AC') : '') +
            //     (el.HasNAC ? (serviceType.includes("Non AC") ? '' : ', Non AC') : '') +
            //     (el.HasSeater ? (serviceType.includes("Seater") ? '' : ', Seater') : '') +
            //     (el.HasSleeper ? (serviceType.includes("Sleeper") ? '' : ', Sleeper') : '') +
            //     (el.BusType ? (serviceType.includes(el.BusType) ? '' : ', ' + el.BusType) : '') +
            //     (el.Arrangement ? (serviceType.includes(el.Arrangement) ? '' : ', ' + el.Arrangement) : '');
        } else {
            // busType = (el.HasAC ? "AC, " : "") + (el.HasNAC ? " Non AC, " : "") + (el.HasSeater ? " Seater, " : "") + (el.HasSleeper ? " Sleeper, " : "") + (el.BusType ? el.BusType + ', ' : " ") + (el.Arrangement ? el.Arrangement : "")
        }
        return busType;
    }
    const uniquePickDrop = (data) => {
        let o = {};
        return data.filter(obj => !o[obj.name] && (o[obj.name] = true))
    }
    const parsePickdrop = (pickDrop) => {
        let filteredPickdrop = pickDrop.map(el => ({ 'name': (el.PickupName ? el.PickupName : el.DropoffName), 'time': (el.PickupTime ? el.PickupTime : el.DropoffTime), 'city': el.CityName }))
        filteredPickdrop = uniquePickDrop(filteredPickdrop);
        filteredPickdrop = filteredPickdrop.sort((a, b) => new Date(a.time) - new Date(b.time));
        return filteredPickdrop;
    }

    const showPickDropContent = (pickDrop) => {
        if (pickDrop && pickDrop.length > 0) {
            const data = parsePickdrop(pickDrop);
            return data.map((el, index) =>
                <div key={index} className='service--route--wise--dtls'>
                    <div className='top--wrap'>
                        <div className='top--wrap--left'>{el.city}</div>
                        <div className='top--wrap--right'>
                            <div style={{ marginRight: '4px' }}>{renderImg('clock')}</div>
                            <div>{get24HoursDateTime(el.time)}</div>
                        </div>
                    </div>
                    <div className='bottom--dtls'>
                        {el.name}
                    </div>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            <div className="service--route--layer"> </div>
            <div className='service--route--dtls--wrapper'>
                <div className='service--route--header'>
                    <div>{`${t(SRD)} ${data.TripCode}`}</div>
                    <div onClick={() => close(false)}>{renderImg('WhiteCross')}</div>
                </div>
                <div className='service--route--depot--details'>
                    {/* <div>{`${t(DEPOT_NAME)} ${data.CompanyName.toUpperCase()}`}</div> */}
                    <div>{`${t(BUS_TYPE)} ${showBusType(data)}`}</div>
                </div>
                <div className='service--route--depot--details--wrapper'>
                    {showPickDropContent(pickDrop)}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ServiceRouteDtls;